import { render } from "./EditCustomerProductGroupView.vue?vue&type=template&id=7a04e7d7"
import script from "./EditCustomerProductGroupView.vue?vue&type=script&lang=js"
export * from "./EditCustomerProductGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__